import React from 'react'
import "./Text.css";
import { useState } from "react";
import { app, database } from "../../firebaseConfig";
import { collection, setDoc, doc, getDoc } from "firebase/firestore";

export const Text = () => {

  const [name, setName] = useState("");
  const [content, setContent] = useState("");
  const [password, setPassword] = useState("");

  async function submit(e) {
    e.preventDefault()
    const collectionRef = doc(database, "Users", password);
    window.scrollTo(window.top);
    if (content !== "") {
      await setDoc(collectionRef, {
        Name: name,
        Password: password,
        Content: content,
      })
      .then(() => {
        setTimeout(function () {
          document.getElementById("added").style.display = "none";
        }, 4000);
        document.getElementById("added").style.display = "block";
        setName("");
        setContent("");
        setPassword("");
      })
      .catch((err) => {
        alert(err.message);
      });
    } else {
      const Data = await getDoc(collectionRef);
      if (Data.exists()) {
        setName(Data.data().Name);
        setPassword(Data.data().Password);
        setContent(Data.data().Content);
        setTimeout(function () {
          document.getElementById("retrieved").style.display = "none";
        }, 4000);
        document.getElementById("retrieved").style.display = "block";
      } else {
        setTimeout(function () {
          document.getElementById("failed").style.display = "none";
        }, 4000);
        document.getElementById("failed").style.display = "block";
      }
    }
  }

  return (
    <div id="textSection">
        <form  onSubmit={submit}>
          <div id="data">
            <label>Your Name :</label>
            <input
              type="text" required id="nametxt" value={name} onChange={(e) => setName(e.target.value)}></input>
            <br />
            <br />
            <br />
          </div>
          <div id="data">
            <label>Your content goes here :</label>
            <br />
            <textarea
              type="text"
              id="contenttxt"
              placeholder="Type Here..."
              value={content}
              onChange={(e) => setContent(e.target.value)}></textarea>
            <br/>
            <p style={{color:"red"}}>
              Please do not provide any sensitive data like passwords, pins, api keys, etc.
            </p>
            <br />
            <br />
            <br />
            <br />
          </div>
          <div id="data">
            <label>Create a Password, as strong as you 😉 :</label>
            <input
              type="password"
              required
              id="passwordtxt"
              value={password}
              onChange={(e) => setPassword(e.target.value)}></input>
            <br />
            <br />
          </div>
          <center>
            <div>
              <button type="submit" id="save">
                Save/Retrieve
              </button>
            </div>
          </center>
        </form>
    </div>
  )
}
